import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useLanguage } from './contexts/LanguageContext';
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export function ProtectedRoute({ children }) {
	const { currentUser } = useAuth();

	return currentUser ? children : <Navigate to='/' />;
}

export function AdminRoute({ children }) {
	const { currentUser } = useAuth();
	const [loading, setLoading] = useState(true);
	const [isAdmin, setIsAdmin] = useState(false);

	useEffect(() => {
		const checkAdminStatus = async () => {
			if (!currentUser) {
				setLoading(false);
				return;
			}

			try {
				const getPerson = httpsCallable(functions, 'getPerson');
				const result = await getPerson({ personId: currentUser.uid });
				const person = result.data.person;
				setIsAdmin(person.isAdmin || false);
			} catch (error) {
				console.error('Error checking admin status:', error);
				setIsAdmin(false);
			}

			setLoading(false);
		};

		checkAdminStatus();
	}, [currentUser]);

	const { t } = useLanguage();

	if (loading) {
		return (
			<div className='min-h-screen flex items-center justify-center'>
				<div className='text-xl'>{t('loading')}</div>
			</div>
		);
	}

	if (!currentUser) {
		return <Navigate to='/' />;
	}

	if (!isAdmin) {
		return <Navigate to={`/${currentUser.uid}`} />;
	}

	return children;
}

export function PublicRoute({ children }) {
	const { currentUser } = useAuth();

	// If user is already logged in, don't show login page
	// Let them continue to their intended destination
	return children;
}
